<script>
    import Map from "./Map.svelte";

    export let districtsTopo; // TopoJSON of courts
    export let statesTopo; // TopoJSON of US states
    export let cities; // Some large cities in the U.S. plus Minneapolis
    export let data = []; // [{ court_id: "001", date_filed: "2023-01-01" }, ...]
    export let mapping = []; // [{ state_abbreviation: "ca", "state_name": "California", ... }]
    export let courts_mapping = []; // [{ court_id: "akd", "court_name": "District of Alaska", ... }] Note for future refactoring, there might be a way to combine the two mapping JSONs
    export let by_district;
    export let by_state;
    export let map_dek;

    let show = "district";
</script>

<div class="max-width-md">
    <div class="controls">
        <div class="chart-context">{ map_dek }</div>
        <div class="toggle">
            
            <button
                class:active={show === "district"}
                on:click={() => (show = "district")}
            >
                {by_district}
            </button>
            <button
                class:active={show === "state"}
                on:click={() => (show = "state")}
            >
                {by_state}
            </button>
        </div>
    </div>
    <div id="map-wrapper">
        <div class:hidden={show != "state"}>
        <Map
            {data}
            {districtsTopo}
            {statesTopo}
            {cities}
            type="state"
            {mapping}
            {courts_mapping}
            wrapperID="#map-wrapper"
        />
        </div>
        <div class:hidden={show != "district"}>
            <Map
                {data}
                {districtsTopo}
                {statesTopo}
                {cities}
                type="district"
                {mapping}
                {courts_mapping}
                wrapperID="#map-wrapper"
            />
        </div>

    </div>
    
</div>
<style>
    #map-wrapper {
        margin: var(--spacing0) 0;
    }
</style>
